import { Account } from '../generated-types';
import { isNotBlacklisted } from '../services/accountFilters';

type Props = {
    allAccounts: Account[] | undefined;
    validAccounts: Account[] | undefined;
};

const filterInvalidAccounts = ({ allAccounts, validAccounts }: Props): Account[] | undefined => {
    if (!allAccounts) {
        return undefined;
    }

    const validAccountNumbers =
        validAccounts && validAccounts.length > 0 ? new Set(validAccounts.map((ac) => ac.accountNumber.value)) : null;

    const filteredAccounts = allAccounts.filter((ac) => {
        const isValid = validAccountNumbers ? validAccountNumbers.has(ac.accountNumber.value) : false;
        return !isValid && isNotBlacklisted(ac);
    });

    return filteredAccounts.length ? filteredAccounts : undefined;
};

export default filterInvalidAccounts;
